import { render } from "./SfIcon.vue?vue&type=template&id=cfd3e9b8&scoped=true"
import script from "./SfIcon.vue?vue&type=script&lang=js"
export * from "./SfIcon.vue?vue&type=script&lang=js"

import "./SfIcon.vue?vue&type=style&index=0&id=cfd3e9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd3e9b8"]])

export default __exports__